export default {
    'wallet.jpg': {
        src: 'cadfaa_61d35338acab4e22845bf03d31460883.jpg',
        width: 800,
        height: 600
    },
    'team-3.jpg': {
        src: 'cadfaa_f3cf770c59ba4164acb075b57f10c3fc.jpg',
        width: 1000,
        height: 667
    },
    'team-2.jpg': {
        src: 'cadfaa_f7c06c0b22964d7d851d6a14160837da.jpg',
        width: 1000,
        height: 667
    },
    'team-1.jpg': {
        src: 'cadfaa_e3ce49014ed946d6a2c92f539b7bbe3e.jpg',
        width: 1000,
        height: 667
    },
    'iphone_cover.jpg': {
        src: 'cadfaa_22cb6cf2b7394f0e9f5a2b9e42d10b89.jpg',
        width: 800,
        height: 600
    },
    'sneakers.jpg': {
        src: 'cadfaa_c50acce240734dd781c4d50593a9865d.jpg',
        width: 800,
        height: 600
    },
    'cupcake.jpg': {
        src: 'cadfaa_ed2344d9764b46f99f750924a27e15ea.jpg',
        width: 800,
        height: 600
    },
    'faq.png': {
        src: 'cadfaa_8561f14a0bce4ede8b442b40f8214f1d.png',
        width: 100,
        height: 100
    },
    'sunbeam.jpg': {
        src: 'cadfaa_2d4c979fcd4d44228cd314c0562683a4.jpg',
        width: 750,
        height: 563
    },
    'rooms-3.jpg': {
        src: 'cadfaa_ed26105b70d74ff7a1e47401aef216e4.jpg',
        width: 1280,
        height: 956
    },
    'rooms-2.jpg': {
        src: 'cadfaa_897545a9ae564dfc9b9a3a569e2a3594.jpg',
        width: 1280,
        height: 853
    },
    'rooms-1.jpg': {
        src: 'cadfaa_523e9fa714274537a431877c98a478ea.jpg',
        width: 1280,
        height: 846
    },
    'news-3.jpg': {
        src: 'cadfaa_3140d3283e0d4d8185425d2b306cfd0a.jpg',
        width: 1000,
        height: 667
    },
    'news-2.jpg': {
        src: 'cadfaa_d6185d77589d482fb7e19c5bf33f110c.jpg',
        width: 1000,
        height: 666
    },
    'news-1.jpg': {
        src: 'cadfaa_4be4dce7ffe54f70a9972e5c5ad88707.jpg',
        width: 1000,
        height: 667
    },
    'logo_4.png': {
        src: 'cadfaa_03a3be6fd25d419aac23317631296c3f.png',
        width: 100,
        height: 100
    },
    'logo_3.png': {
        src: 'cadfaa_7c1b8a795c304dffaf6fbe416183d120.png',
        width: 100,
        height: 100
    },
    'logo_1.png': {
        src: 'cadfaa_f6f3fca8a79d41ad92d630177d8e93a8.png',
        width: 100,
        height: 100
    },
    'hat.jpg': {
        src: 'cadfaa_1d9425f562fb4c34b9828fe861835222.jpg',
        width: 800,
        height: 600
    },
    'budding_tree.jpg': {
        src: 'cadfaa_fe9eb39bfa1c4f0fbb575ca21e402e33.jpg',
        width: 1000,
        height: 750
    },
    'bloom.jpg': {
        src: 'cadfaa_848ea7fa3446485c914b65749497c1a1.jpg',
        width: 1000,
        height: 750
    },
    'beauty_cream.jpg': {
        src: 'cadfaa_074e55270c984f7cb62b60eac33b955f.jpg',
        width: 800,
        height: 600
    }
}
